import type { GetRequestOptions, PutConfigObject } from "app/services/fetchService";

/**
 * Keys of the per-account `/sales-api/account-settings/{key}` store. The spelling is the backend's: a key the
 * backend does not know is not an error, it reads as unset forever — so these strings must match exactly.
 */
export const accountSettingKeyMap = {
    accountOptedInIndustryTaxonomy: "AccountOptedInIndustryTaxonomy",
} as const;

export type AccountSettingKey = (typeof accountSettingKeyMap)[keyof typeof accountSettingKeyMap];

export type ExtensionDefaultsPayload = { readonly value: string };

export interface IAccountSettingsApiService {
    /* @note read a per-account flag. A key that was never written has no guaranteed shape — callers must
       treat anything other than an explicit `true` (incl. a rejected request) as unset. */
    fetchSetting(key: AccountSettingKey, options?: Readonly<GetRequestOptions>): Promise<string | null>;

    /* @note persist a per-account flag as a `?value=` query param with no body */
    saveSetting(key: AccountSettingKey, value: boolean, options?: Readonly<PutConfigObject>): Promise<void>;

    /* @note read the extension settings blob (raw serialized string, or null when unset) */
    fetchExtensionDefaults(options?: Readonly<GetRequestOptions>): Promise<string | null>;

    /* @note persist the extension settings blob, scoped to the Chrome extension */
    saveExtensionDefaults(payload: ExtensionDefaultsPayload, options?: Readonly<PutConfigObject>): Promise<void>;
}
